import React, { Component } from "react";
import {
  MDBNavbar, MDBNavbarNav, MDBNavItem, MDBCollapse,
  MDBHamburgerToggler
} from 'mdbreact';
import { BrowserRouter as Router } from 'react-router-dom';


class Mobile_menu extends Component {
  state = {
    collapse1: false,
    collapseID: ''
  }

  toggleCollapse = collapseID => () => {
    this.setState(prevState => ({ collapseID: (prevState.collapseID !== collapseID ? collapseID : '') }));
  }

  toggleSingleCollapse = collapseId => {
    this.setState({
      ...this.state,
      [collapseId]: !this.state[collapseId]
    });
  }


  render() {

    return (

      <Router>

        <MDBNavbar>
          <MDBHamburgerToggler id="hamburger1" onClick={() => this.toggleSingleCollapse('collapse1')} />
          <MDBCollapse isOpen={this.state.collapse1} navbar>
            <MDBNavbarNav left>
              <MDBNavItem>
                <div className="dropdown">
                  <a className="nav-link" href={process.env.PUBLIC_URL + '/'}>Home</a>
                </div>
              </MDBNavItem>
              <MDBNavItem>
                <div className="dropdown">
                  <a className="nav-link" href={process.env.PUBLIC_URL + '/about_us'}>Who We Are</a>
                </div>
              </MDBNavItem>
              <MDBNavItem>
                <div className="dropdown">
                  <a className="nav-link" href={process.env.PUBLIC_URL + '/services'}>Our Expertise</a>
                </div>
              </MDBNavItem>
              <MDBNavItem>
                <div className="dropdown">
                  <a className="nav-link" href={process.env.PUBLIC_URL + '/GetFaq'}>FAQ</a>
                </div>
              </MDBNavItem>
              <MDBNavItem>
                <div className="dropdown">
                  <a className="nav-link" href={process.env.PUBLIC_URL + '/carrer_01'}>Careers</a>
                </div>
              </MDBNavItem>
              <MDBNavItem>
                <div className="dropdown">
                  <a className="nav-link" href={process.env.PUBLIC_URL + '/Contact_01'}>Contact</a>
                </div>
              </MDBNavItem>
            </MDBNavbarNav>
          </MDBCollapse>
        </MDBNavbar>
      </Router>
    );
  }
}

export default Mobile_menu;